module.exports = {
  "name": "Hammerath - AI驱动的教学可视化平台",
  "short_name": "Hammerath",
  "description": "专业的AI驱动教学可视化平台，帮助教育工作者和学生创建精美的数学动画、教学视频和可视化内容。",
  "start_url": "/",
  "display": "standalone",
  "theme_color": "#222222",
  "background_color": "#ffffff",
  "orientation": "portrait-primary",
  "scope": "/",
  "lang": "zh-CN",
  "categories": ["education", "productivity", "utilities"],
  "icons": [
    {
      "src": "/public/favicon.ico",
      "sizes": "16x16 32x32",
      "type": "image/x-icon",
      "purpose": "favicon"
    },
    {
      "src": "/src/assets/hammerath-logo-new.png",
      "sizes": "192x192",
      "type": "image/png",
      "purpose": "any maskable"
    },
    {
      "src": "/src/assets/hammerath-logo-new.png", 
      "sizes": "512x512",
      "type": "image/png",
      "purpose": "any"
    }
  ],
  "screenshots": [
    {
      "src": "/src/assets/hammerath-logo-new.png",
      "sizes": "1280x720",
      "type": "image/png",
      "platform": "wide",
      "label": "Hammerath主界面"
    }
  ],
  "related_applications": [],
  "prefer_related_applications": false,
  "dir": "ltr",
  "iarc_rating_id": "",
  "shortcuts": [
    {
      "name": "作品展示",
      "short_name": "展示",
      "description": "查看精美的数学动画作品集",
      "url": "/showcase",
      "icons": [
        {
          "src": "/src/assets/hammerath-logo-new.png",
          "sizes": "96x96"
        }
      ]
    },
    {
      "name": "开始创作",
      "short_name": "创作",
      "description": "使用AI工具创建数学动画",
      "url": "/app/home",
      "icons": [
        {
          "src": "/src/assets/hammerath-logo-new.png",
          "sizes": "96x96"
        }
      ]
    }
  ]
}
;